import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ChecklistSettingsDashboardQueryKeys } from "modules/ChecklistSettingsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { ChecklistTemplate } from "models";

export const useUpdateTemplateMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: ChecklistTemplate) => (await ApiInstance.post("/checklists/template/update", payload, ENV.dealerBaseURL)).data,
    onSuccess: ({ id, name, default_only }) => {
      const templates = typedQueryClient.getQueryData(ChecklistSettingsDashboardQueryKeys.checklistTemplates);
      if (!templates) return;

      const templateIdx = templates.findIndex(template => template.checklist_template_id === id);
      if (templateIdx < 0) return;

      typedQueryClient.setQueryData(
        ChecklistSettingsDashboardQueryKeys.checklistTemplates,
        templates.with(templateIdx, { checklist_template_id: id, name, default_only })
      );
    }
  });
